// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GiftIconOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 55 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g clipPath="url(#GiftIconOutline_tsx__a)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M48.802 28.181H5.6c-.009 0-.017.003-.026.003H3.2v-6.407c0-.88.716-1.596 1.595-1.596h44.811c.879 0 1.594.716 1.594 1.596l.004 6.404h-2.402ZM47.2 58.62c0 .862-.7 1.562-1.562 1.562H8.762c-.861 0-1.562-.7-1.562-1.562V31.381h40V58.62ZM12.92 7.825c.196-1.535 1.416-3.003 3.038-3.653a4.848 4.848 0 0 1 1.813-.353c1.294 0 2.62.515 3.862 1.522 3.115 2.524 3.825 7.762 3.964 10.807a24.24 24.24 0 0 0-.019.565c-1.285-.276-3.359-.835-6.38-1.967-2.746-1.03-6.684-3.72-6.278-6.92Zm19.847-2.484C34.01 4.334 35.335 3.82 36.63 3.82c.616 0 1.225.117 1.814.353 1.621.651 2.842 2.119 3.036 3.653.407 3.2-3.53 5.892-6.277 6.921-3.021 1.132-5.094 1.69-6.38 1.967-.004-.212-.012-.44-.024-.678.176-3.355 1.063-8.338 3.97-10.694Zm16.839 11.64H38.059c3.879-1.956 7.122-5.418 6.595-9.56-.342-2.69-2.312-5.132-5.02-6.219C36.726.034 33.49.637 30.752 2.855c-1.65 1.338-2.78 3.157-3.552 5.086-.773-1.93-1.902-3.748-3.552-5.086-2.736-2.217-5.974-2.82-8.882-1.653-2.707 1.086-4.677 3.527-5.02 6.22-.527 4.141 2.717 7.603 6.595 9.56H4.795A4.8 4.8 0 0 0 0 21.776v6.407a3.201 3.201 0 0 0 3.198 3.197H4v27.24a4.768 4.768 0 0 0 4.762 4.762h36.876A4.768 4.768 0 0 0 50.4 58.62V31.381h.802a3.201 3.201 0 0 0 3.198-3.197v-6.407a4.8 4.8 0 0 0-4.794-4.796Z"
				fill="#fff"
			/>
		</g>
		<defs>
			<clipPath id="GiftIconOutline_tsx__a">
				<path fill="#fff" d="M0 0h54.4v64H0z" />
			</clipPath>
		</defs>
	</svg>
);
export default GiftIconOutline;
